import React from 'react';
import {connect} from 'react-redux';
import _ from 'lodash';
import cn from 'classnames';
import QueryString from 'query-string';
import moment from 'moment';

import ApplicationMessages from '../inAppMessages/ApplicationMessages';
import ApplicationToast from '../inAppMessages/ApplicationToast';
import { toastActions } from '../inAppMessages/toastActions';
import EXCHANGE_RATES_CONTROLLER from '../../controllers/exchangeRates';
import GLOBAL_FILTER_CONTROLLER from '../../controllers/globalFilter';
import LANGUAGE_CONTROLLER from '../../controllers/languages';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import ExchangeRatesFilterPanel, {ALL_CURRENCY_KEY} from './ExchangeRatesFilterPanel';
import ExistingExchangeRates from './ExistingExchangeRates';
import ExchangeRatesToolbar from './ExchangeRatesToolbar';
import ExchangeRatesImportModal from './ExchangeRatesImportModal';
import ExchangeRatesImportModalV2 from './ExchangeRatesImportModalV2';
import ImportExchangeRatesStatusData from './ImportExchangeRatesStatusData';
import { SimpleDateSelector } from '../selectors/date/SimpleDateSelector';
import LoadingSpinner from '../spinners/LoadingSpinner';
import HighlightOninAppMessage from '../inAppMessages/HighlightOninAppMessage';
import AuthorizedResource from '../authorization/AuthorizedResource';
import authorize from '../../utils/auth';
import UploadModal from '../modals/UploadModal';

import Logger, {LOG_LEVELS, ALL_MESSAGES} from '../../utils/logger';
import { TableConfig } from '../../utils/appConfig';
import ComponentUtil from '../../utils/componentUtil';
import { FileValidationHelper } from '../../utils/helpers';
import getClientConfig from '../../utils/getClientConfig';

const FORM_NAME= 'EXCHANGE_RATES_PAGE';
const log = new Logger(FORM_NAME, LOG_LEVELS.DEBUG);

const DATE_FORMAT = 'YYYY-MM-DD';
const SUPPORTED_EXCHANGE_RATE_COUNTRY_CODES = ['BE', 'CZ', 'PL', 'CH', 'NO', 'GB'];

const getSupportedExchangeRateProviders = () => {
    const config = getClientConfig();
    const providersString = config.supportedExchangeRateProviders || '';
    return providersString.split(',').map(code => code.trim()).filter(Boolean);
};

const SUPPORTED_EXCHANGE_RATE_PROVIDERS = getSupportedExchangeRateProviders();

export class ExchangeRatesPage extends React.Component {

    constructor(props) {
        super(props);
        log.debug('constructor(): ExchangeRatesPage: ', props);
        this.onSearchClickHandler = this.onSearchClickHandler.bind(this);
        this.openExchangeRatesImportModal = this.openExchangeRatesImportModal.bind(this);
        this.openExchangeRatesXmlImportModal = this.openExchangeRatesXmlImportModal.bind(this);
        this.onExportExchangeRatesClick = this.onExportExchangeRatesClick.bind(this);
        this.genericCheckboxHandlerFactory = this.genericCheckboxHandlerFactory.bind(this);
        this.closeExchangeRatesImportModal = this.closeExchangeRatesImportModal.bind(this);
        this.closeExchangeRatesXmlImportModal = this.closeExchangeRatesXmlImportModal.bind(this);
        this.openImportExchangeRatesModal = this.openImportExchangeRatesModal.bind(this);
        this.closeImportExchangeRatesModal = this.closeImportExchangeRatesModal.bind(this);
        this.startImportExchangeRatesHandler = this.startImportExchangeRatesHandler.bind(this);
        this.onUploadModalSubmit = this.onUploadModalSubmit.bind(this);
        this.selectionHandler = this.selectionHandler.bind(this);
        this.startImportHandler = this.startImportHandler.bind(this);
        this.cancelImportHandler = this.cancelImportHandler.bind(this);
        this.onFetchDataHandler = this.onFetchDataHandler.bind(this);
        this.getFilterParams = this.getFilterParams.bind(this);
        this.getInitialPaginationInfo = this.getInitialPaginationInfo.bind(this);
        this.handleToastDismiss = this.handleToastDismiss.bind(this);
        this.setModalRef = element => {
            this.modalRef = element;
        };
        this.allCurrencyKey = LANGUAGE_CONTROLLER.format(this.props.languages, ALL_CURRENCY_KEY);
        this.state = {
            disableCancelImport: true,
            importExchangeRatesModalOpen: false,
            importExchangeRatesXmlModalOpen: false,
            importExchangeRatesViaOperationModalOpen: false,
            selection: {},
            showProgressTracker: false,
            exchangeRatesLoading: false,
            paginationInfo: null,
            filterSelection: null,
            showOperationModal: false,
            selectedOperation: null
        };
    }

    getInitialPaginationInfo() {
        return {
            pageNumber: 1,
            pageSize: this.state.paginationInfo ? this.state.paginationInfo.pageSize : TableConfig.PAGINATION.STANDARD_LEVEL_ONE_PAGE_SIZE,
        };
    }

    onSearchClickHandler(selection) {
        log.debug('onSearchClickHandler(): selection: ', selection);
        this.props.doUnloadExchangeRates();
        this.setState({ exchangeRatesLoading: true});
        let filterOptions = Object.assign({}, selection, this.getInitialPaginationInfo());
        this.setState({
            filterSelection: selection
        });
        if(filterOptions.fromCurrency === this.allCurrencyKey) {
            delete filterOptions.fromCurrency;
        }
        if(filterOptions.toCurrency === this.allCurrencyKey) {
            delete filterOptions.toCurrency;
        }
        this.props.doGetExchangeRates(Object.assign({}, filterOptions), ()=>{
            this.setState({
                exchangeRatesLoading: false
            }); 
        });
        //Update URL
        let parsedQueryParams = QueryString.parse(this.props.location.search);
        parsedQueryParams.startDate = selection.startDate;
        parsedQueryParams.endDate = selection.endDate;
        ComponentUtil.updateUrlParams(this.props.location, this.props.history, parsedQueryParams);
    }

    openExchangeRatesImportModal() {
        log.debug('openExchangeRatesImportModal()');
        log.clearAllDictionaryErrors(ALL_MESSAGES.EXCHANGE_RATES_IMPORT_SUCCESS);  
        let selection = Object.assign({}, this.state.selection);
        selection.importStartDate = moment().utc(new Date()).subtract(1, 'months').format(DATE_FORMAT);
        selection.importEndDate = moment.utc(new Date()).format(DATE_FORMAT);
       this.setState({
            importExchangeRatesModalOpen: true,
            selection: selection
        });
    }
    openExchangeRatesXmlImportModal() {
        log.debug('openExchangeRatesXmlImportModal()');
        this.setState({
            importExchangeRatesXmlModalOpen: true
        });
    }

    openImportExchangeRatesModal() {
        log.debug('openImportExchangeRatesModal()');
        let selection = Object.assign({}, this.state.selection);
        selection.exchangeRatesStartDate = moment().utc(new Date()).subtract(1, 'months').format(DATE_FORMAT);
        selection.exchangeRatesEndDate = moment.utc(new Date()).format(DATE_FORMAT);
        this.setState({
            importExchangeRatesViaOperationModalOpen: true,
            selection: selection
        });
    }

    closeExchangeRatesImportModal() {
        log.debug('closeExchangeRatesImportModal()');
        log.clearDictionaryError(ALL_MESSAGES.INVALID_DATE_RANGE);
        this.setState({
            importExchangeRatesModalOpen: false
        });
    }

    closeExchangeRatesXmlImportModal() {
        log.debug('closeExchangeRatesXmlImportModal()');
        this.setState({
            importExchangeRatesXmlModalOpen: false
        });
    }

    closeImportExchangeRatesModal() {
        log.debug('closeImportExchangeRatesModal()');
        this.setState({
            importExchangeRatesViaOperationModalOpen: false
        });
    }
    onUploadModalSubmit(files){
        log.debug('onUploadModalSubmit()');
        this.setState({ importExchangeRatesXmlModalOpen: false});
        log.clearDictionaryError(ALL_MESSAGES.EXCHANGE_RATES_IMPORT_SUCCESS); 
        log.clearDictionaryError(ALL_MESSAGES.VIRUS_SCAN_FAILED);
        log.clearDictionaryError(ALL_MESSAGES.FAILED_TO_RETRIEVE_EXCHANGE_RATES);
        log.clearDictionaryError(ALL_MESSAGES.FAILED_TO_IMPORT_EXCHANGE_RATES);
        log.clearDictionaryError(ALL_MESSAGES.FAILED_TO_IMPORT_EXCHANGE_RATES_LARGE_FILE_SIZE);
        log.clearDictionaryError(ALL_MESSAGES.FILE_IMPORT_ERROR_EXTENSION_FORBIDDEN);
        log.clearDictionaryError(ALL_MESSAGES.FILE_IMPORT_ERROR_EXTENSION_TOO_LONG);
        log.clearDictionaryError(ALL_MESSAGES.FILE_IMPORT_ERROR_FILENAME_TOO_LONG);
        log.clearDictionaryError(ALL_MESSAGES.FILE_IMPORT_ERROR_FILENAME_FORBIDDEN);
        log.clearDictionaryError(ALL_MESSAGES.FILE_IMPORT_ERROR_CONTENTTYPE_FORBIDDEN);
        log.clearDictionaryError(ALL_MESSAGES.FILE_IMPORT_ERROR_CONTENTTYPE_MISMATCH);
        log.clearAllDictionaryErrors(ALL_MESSAGES.EXCHANGE_RATES_IMPORT_WARNING);  
        let removeExistingRates = (this.state.selection && this.state.selection.removeExistingRates) || false;
        const getExchangeRatesFilterParams = Object.assign({}, this.getFilterParams(),this.getInitialPaginationInfo());
        this.props.onImportExchangeRateXml(files,removeExistingRates, (response) => {
            let isPartiallyFailed = false;
            log.clearAllDictionaryErrors();
            isPartiallyFailed = (response && response.result && response.result.indexOf('failures') > -1);
             //Load the existing data on the UI after upload success
            this.props.doGetExchangeRates(getExchangeRatesFilterParams, (error,response) => {
                if(response && isPartiallyFailed){
                    log.setDictionaryMessage(ALL_MESSAGES.EXCHANGE_RATES_IMPORT_WARNING);
                }else if(response && !isPartiallyFailed){
                    log.setDictionaryMessage(ALL_MESSAGES.EXCHANGE_RATES_IMPORT_SUCCESS);  
                }
                else{
                    log.setDictionaryMessage(ALL_MESSAGES.FAILED_TO_RETRIEVE_EXCHANGE_RATES);
                }
            })
        },(error) => 
        {
            switch(error.status) {
                case 406:
                    log.setDictionaryMessage(ALL_MESSAGES.VIRUS_SCAN_FAILED);
                    break;
                case 400:
                    error.text()
                        .then((errorMessage) => {
                            let validationMessage = FileValidationHelper.getFileValidationMessage(errorMessage);
                            if (validationMessage) {
                                log.setDictionaryMessage(validationMessage);
                            } else {
                                log.setDictionaryMessage(ALL_MESSAGES.FAILED_TO_IMPORT_EXCHANGE_RATES);
                            }
                        });
                    break;
                case 413:
                    log.setDictionaryMessage(ALL_MESSAGES.FAILED_TO_IMPORT_EXCHANGE_RATES_LARGE_FILE_SIZE);
                    break;
                default:
                    log.setDictionaryMessage(ALL_MESSAGES.FAILED_TO_IMPORT_EXCHANGE_RATES);
            }
            //Load the existing data on the UI after failure
            this.props.doGetExchangeRates(getExchangeRatesFilterParams, (error,response) => {
                if(error){
                    log.setDictionaryMessage(ALL_MESSAGES.FAILED_TO_RETRIEVE_EXCHANGE_RATES);
                }
            })
         },
        );
    }

    selectionHandler(keyValue) {
        log.debug('selectionHandler() - keyValue: ', keyValue);
        let key =  Object.keys(keyValue)[0];
        let value =  Object.values(keyValue)[0];
        let selection = Object.assign({}, this.state.selection);
        if(_.isEmpty(value)) {
          delete selection[key];
        } else {
          selection = Object.assign(selection, keyValue);
        }
        this.setState({
          selection: selection
        });
    }

    startImportHandler() {
        log.debug('startImportHandler()');
        const selection = this.state.selection || {};
        const startDate = moment.utc(selection.importStartDate, 'YYYY-MM-DD');
        const endDate = moment.utc(selection.importEndDate, 'YYYY-MM-DD');
        const dateNow = moment.utc(new Date());
        if(!startDate.isValid() || !endDate.isValid() || startDate.isAfter(dateNow) || endDate.isAfter(dateNow) || startDate.isAfter(endDate)){
            log.setDictionaryMessage(ALL_MESSAGES.INVALID_DATE_RANGE);
        } else {
            log.clearDictionaryError(ALL_MESSAGES.INVALID_DATE_RANGE);
            const apiParams = {
                startDate: selection.importStartDate,
                endDate: selection.importEndDate,
                countries: SUPPORTED_EXCHANGE_RATE_COUNTRY_CODES,
                removeExistingRates: selection.removeExistingRates
            }; 
            const getExchangeRatesFilterParams = Object.assign({}, this.getFilterParams(),this.getInitialPaginationInfo());
            this.props.doRemoveAllAndRetrieveOnline(apiParams, getExchangeRatesFilterParams, () => {;
                this.closeExchangeRatesImportModal();
                this.setState({ disableCancelImport: true, showProgressTracker: false });
            });
            this.setState({ disableCancelImport: false, showProgressTracker: true });
        }
    }

    cancelImportHandler() {
        log.debug('cancelImportHandler()');
        this.setState({ disableCancelImport: true });
        this.props.doCancelImport();
    }

    startImportExchangeRatesHandler() {
        log.debug('startImportExchangeRatesHandler()');
        log.clearAllDictionaryErrors();
        
        const selection = this.state.selection || {};
        const startDate = selection.exchangeRatesStartDate;
        const endDate = selection.exchangeRatesEndDate;
        
        if (!startDate || !endDate) {
            log.setDictionaryMessage(ALL_MESSAGES.INVALID_DATE_RANGE);
            return;
        }
        
        // Close the modal first
        this.closeImportExchangeRatesModal();
        
        // Call operation service for all providers
        const providers = SUPPORTED_EXCHANGE_RATE_PROVIDERS;
        
        const operationRequest = {
            entityIds: providers,
            customerId: this.props.customerId,
            userId: this.props.userName,
            parameters: {
                StartDate: startDate,
                EndDate: endDate
            },
            jobName: `${moment(startDate, DATE_FORMAT).format('DD-MM-YYYY')} to ${moment(endDate, DATE_FORMAT).format('DD-MM-YYYY')}`
        };
        
        this.props.onStartImportExchangeRates(
            operationRequest,
            () => {
                log.debug('Import Exchange Rates started for all providers');
                log.setDictionaryMessage(ALL_MESSAGES.IMPORT_EXCHANGE_RATES_STARTED);
            },
            (error) => {
                log.debug('Import Exchange Rates failed', error);
                log.setDictionaryMessage(ALL_MESSAGES.IMPORT_EXCHANGE_RATES_GENERIC_ERROR);
            }
        );
    }

    getFilterParams() {
        let parsedQueryParams = QueryString.parse(this.props.location.search);
        let filterParams = Object.assign({}, this.state.filterSelection, parsedQueryParams, GLOBAL_FILTER_CONTROLLER.getAll());
        if(filterParams.fromCurrency === this.allCurrencyKey) {
            delete filterParams.fromCurrency;
        }
        if(filterParams.toCurrency === this.allCurrencyKey) {
            delete filterParams.toCurrency;
        }
        return filterParams;
    }

    onFetchDataHandler(paginationInfo={}) {
        log.debug('onFetchDataHandler() - paginationInfo: ', paginationInfo);
        this.setState({
            exchangeRatesLoading: true
        }); 
        let filterOptions = this.getFilterParams();
        this.props.doGetExchangeRates(Object.assign({}, filterOptions, paginationInfo), ()=>{
            this.setState({
                exchangeRatesLoading: false,
                paginationInfo: paginationInfo
            }); 
        });
    }

    genericCheckboxHandlerFactory(isChecked) {
          let selection = Object.assign({}, this.state.selection);
          selection.removeExistingRates = isChecked;
          this.setState({
            selection: selection
          });
    }

    onExportExchangeRatesClick() {
        log.debug('onExportExchangeRatesClick()');
        const filterParams = this.getFilterParams();
        if (filterParams.startDate && filterParams.endDate) {
            this.props.doDownloadExchangeRatesCsv({
                startDate: filterParams.startDate,
                endDate: filterParams.endDate,
                fromCurrency: filterParams.fromCurrency,
                toCurrency: filterParams.toCurrency
            });
        }
    }

    componentWillUnmount() {
        log.debug('componentWillUnmount(): ');
        this.props.doUnloadExchangeRates();
    }

    handleToastDismiss(toastId) {
        log.debug('handleToastDismiss(): toastId: ', toastId);
        // Clean up the toast from Redux state when dismissed
        this.props.removeToast(toastId);
    }

    render() {
        log.debug('render(): ', this.props);
        const globalFilterSelection = GLOBAL_FILTER_CONTROLLER.getAll();
        const filterSelection = Object.assign({}, globalFilterSelection, QueryString.parse(this.props.location.search)) ;     
        const selection = this.state.selection || {}; 
        const startImportClasses = cn('primary', {'disabled':_.isEmpty(selection.importStartDate) || _.isEmpty(selection.importEndDate) || !this.state.disableCancelImport});
        const cancelImportDisabled = cn('', {'disabled': this.state.disableCancelImport});
        const exchangeRates = (this.props.exchangeRatesData && this.props.exchangeRatesData.exchangeRates) || [];
        const exchangeRatesCount = (this.props.exchangeRatesData && this.props.exchangeRatesData.totalExchangeRatesCount) || 0;
        return (
            <div data-test="component-exchange-rates-page" className="content-area">
                <s-container>
                    <ApplicationMessages messageIds={[ALL_MESSAGES.FAILED_TO_RETRIEVE_EXCHANGE_RATES,
                                                      ALL_MESSAGES.FAILED_TO_IMPORT_EXCHANGE_RATES,
                                                      ALL_MESSAGES.VIRUS_SCAN_FAILED,
                                                      ALL_MESSAGES.FAILED_TO_IMPORT_EXCHANGE_RATES_LARGE_FILE_SIZE,
                                                      ALL_MESSAGES.FILE_IMPORT_ERROR_EXTENSION_FORBIDDEN,
                                                      ALL_MESSAGES.FILE_IMPORT_ERROR_EXTENSION_TOO_LONG,
                                                      ALL_MESSAGES.FILE_IMPORT_ERROR_FILENAME_TOO_LONG,
                                                      ALL_MESSAGES.FILE_IMPORT_ERROR_FILENAME_FORBIDDEN,
                                                      ALL_MESSAGES.FILE_IMPORT_ERROR_CONTENTTYPE_FORBIDDEN,
                                                      ALL_MESSAGES.FILE_IMPORT_ERROR_CONTENTTYPE_MISMATCH
                                                      ]} messageType="applicationError"/>
                    <ApplicationMessages messageIds={[ALL_MESSAGES.EXCHANGE_RATES_IMPORT_SUCCESS]} messageType="applicationSuccess"/>
                    <ApplicationMessages messageIds={[ALL_MESSAGES.EXCHANGE_RATES_IMPORT_WARNING]} messageType="applicationWarning" />
                    <h1>
                        <span>
                            {LANGUAGE_CONTROLLER.format(this.props.languages, 'TitleExchangeRates')}
                        </span>
                    </h1>
                    {this.props.featureFlags?.EnableExchangeRatesAutoSync && (
                        <s-alert status="warning" class="mb30">
                            <div>
                                <h4 class="margin-top-none margin-bottom-xs"><LanguageStringResolver string='exchangeRates_AutoSyncMessage_1' /></h4>
                                <p class="margin-bottom-none">
                                    <LanguageStringResolver string='exchangeRates_AutoSyncMessage_2_0' /> <b><LanguageStringResolver string='exchangeRates_AutoSyncMessage_2_1' /></b> <LanguageStringResolver string='exchangeRates_AutoSyncMessage_2_2' />
                                    <br />
                                    <LanguageStringResolver string='exchangeRates_AutoSyncMessage_3_0' /> <b><LanguageStringResolver string='exchangeRates_AutoSyncMessage_3_1' /></b> <LanguageStringResolver string='exchangeRates_AutoSyncMessage_3_2' />
                                </p>
                            </div>
                        </s-alert>
                    )}

                    {this.props.featureFlags?.EnableImportExchangeRatesViaERS && (
                        <>
                            <ImportExchangeRatesStatusData
                                showModal={this.state.showOperationModal}
                                setShowModal={(value) => this.setState({ showOperationModal: value })}
                                selectedOperation={this.state.selectedOperation}
                                setSelectedOperation={(value) => this.setState({ selectedOperation: value })}
                                tenantId={this.props.customerId}
                                userId={this.props.userName}
                                onClearInitialMessage={() => log.clearDictionaryError(ALL_MESSAGES.IMPORT_EXCHANGE_RATES_STARTED)}
                            />
                            <ApplicationMessages messageIds={[ALL_MESSAGES.IMPORT_EXCHANGE_RATES_STARTED]} messageType="applicationInfo" />
                        </>
                    )}
                    <ExchangeRatesFilterPanel onSearchClick={this.onSearchClickHandler} filterOptions={filterSelection} />
                    
                    <ExchangeRatesToolbar 
                        onImportClick={this.openExchangeRatesImportModal} 
                        onImportXmlClick={this.openExchangeRatesXmlImportModal}
                        onImportOperationClick={this.openImportExchangeRatesModal}
                        removeExistingRates ={selection.removeExistingRates}
                        genericCheckboxHandlerFactory ={this.genericCheckboxHandlerFactory}
                        enableImportExchangeRatesViaERS={this.props.featureFlags?.EnableImportExchangeRatesViaERS}
                    />
                    <ExistingExchangeRates 
                        data={exchangeRates || []}
                        onFetchData={this.onFetchDataHandler} 
                        loading={this.state.exchangeRatesLoading}
                        totalCount={exchangeRatesCount}
                    />
                    {this.props.featureFlags?.EnableExportExchangeRatesAsCsv && exchangeRates && exchangeRates.length > 0 &&
                        <button 
                            className="mt5 secondary" 
                            data-testid="export-exchange-rates-as-csv" 
                            onClick={this.onExportExchangeRatesClick}
                        >
                            <LanguageStringResolver string='exchangeRates_ExportEntireTableAsCsv' />
                        </button>
                    }
                    <ExchangeRatesImportModal 
                        open={this.state.importExchangeRatesModalOpen} 
                        titleLanguageString='exchangeRatesImportModal_retrieveOnline' 
                        onCloseClick={this.closeExchangeRatesImportModal} 
                        ref={this.setModalRef}
                    >
                        <s-box name='form-panel'>
                            <fieldset>
                                <ApplicationMessages messageIds={[ALL_MESSAGES.INVALID_DATE_RANGE]} messageType="applicationError"/>
                                <s-row>
                                    <s-col span="6">
                                        <HighlightOninAppMessage
                                            scopes={[FORM_NAME]}
                                            messageIds={[ALL_MESSAGES.INVALID_DATE_RANGE]}
                                        >
                                            <label className="mt0 mr20"><LanguageStringResolver string='exchangeRatesImportModal_StartDate' /></label>
                                            <SimpleDateSelector 
                                                selectionHandler={this.selectionHandler}
                                                fieldName={'importStartDate'}
                                                format="yyyy-mm-dd"
                                                value={selection.importStartDate || ''}
                                            />
                                        </HighlightOninAppMessage>
                                    </s-col>
                                    <s-col span="6">
                                        <HighlightOninAppMessage
                                            scopes={[FORM_NAME]}
                                            messageIds={[ALL_MESSAGES.INVALID_DATE_RANGE]}
                                        >
                                            <label className="mt0 mr20"><LanguageStringResolver string='exchangeRatesImportModal_EndDate' /></label>
                                            <SimpleDateSelector 
                                                selectionHandler={this.selectionHandler}
                                                fieldName={'importEndDate'}
                                                format="yyyy-mm-dd"
                                                value={selection.importEndDate || ''}
                                            />
                                        </HighlightOninAppMessage>
                                    </s-col>
                                </s-row>
                                <div className="clear"/>
                            </fieldset>
                        </s-box>
                        
                        <LoadingSpinner show={this.state.showProgressTracker} container={this.modalRef} progressBarOnly={true} strokeWidth={2} trailWidth={1}/>
                        <div className="mt20">
                            <button className={startImportClasses} onClick={this.startImportHandler}>
                                <span>
                                    {LANGUAGE_CONTROLLER.format(this.props.languages, 'exchangeRatesImportModal_StartImport')}
                                </span>
                            </button>
                            <button
                                className="secondary"
                                onClick={this.cancelImportHandler}
                                disabled={cancelImportDisabled}>
                                <span>
                                    {LANGUAGE_CONTROLLER.format(this.props.languages, 'exchangeRatesImportModal_CancelImport')}
                                </span>
                            </button>
                        </div>
                    </ExchangeRatesImportModal>
                    <UploadModal
                        titleKey='exchangeRatesImportModal_uploadXml'
                        open={this.state.importExchangeRatesXmlModalOpen}
                        onClose={this.closeExchangeRatesXmlImportModal}
                        onSubmit={this.onUploadModalSubmit}
                        fileTypes='.xml'
                        maxFileSize={5}
                        maxNumberOfFiles={1}
                    />
                    <ApplicationToast 
                        scope="exchangeRates"
                        testId="exchange-rates-export-toast"
                        onDismiss={this.handleToastDismiss}
                    />
                    {this.props.featureFlags?.EnableImportExchangeRatesViaERS && (
                        <ExchangeRatesImportModalV2
                            open={this.state.importExchangeRatesViaOperationModalOpen}
                            onStartImport={this.startImportExchangeRatesHandler}
                            onCancel={this.closeImportExchangeRatesModal}
                            onDateChange={this.selectionHandler}
                            startDate={selection.exchangeRatesStartDate || ''}
                            endDate={selection.exchangeRatesEndDate || ''}
                        />
                    )}
                </s-container>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const exchangeRatesState = state.exchangeRates;
    return {
        exchangeRatesData: exchangeRatesState && exchangeRatesState.data,
        languages: state.languages,
        featureFlags: state.featureFlag && state.featureFlag.data,
        userName: state.authentication?.data?.userName || "Unknown",
        customerId: state.authentication && state.authentication?.data && state.authentication?.data?.customerId || []
    };
}

function mapDispatchersToProps(dispatch) {
    return {
        doGetExchangeRates: (params, callback) => {
            log.debug('doGetExchangeRates() - params: ', params);
            let apiParmas = {
                startDate:  params.startDate,
                endDate: params.endDate,
                pageNumber: params.pageNumber,
                pageSize: params.pageSize,
                fromCurrency: params.fromCurrency,
                toCurrency: params.toCurrency
            };
            dispatch(EXCHANGE_RATES_CONTROLLER.getAllWithFilters(apiParmas, callback));
        },

        doUnloadExchangeRates: () => {
            log.debug('doUnloadExchangeRates()');
            dispatch(EXCHANGE_RATES_CONTROLLER.unload());
        },

        doRemoveAllAndRetrieveOnline: (params, filterParams, callback) => {
            log.debug('doRemoveAllAndRetrieveOnline(): params: ', params);
            if(params.removeExistingRates) {
                dispatch(EXCHANGE_RATES_CONTROLLER.removeAll(() => {
                    dispatch(EXCHANGE_RATES_CONTROLLER.retrieveOnline(params, filterParams, callback));
                }));
            } else {
                dispatch(EXCHANGE_RATES_CONTROLLER.retrieveOnline(params, filterParams, callback));
            }
        },

        doCancelImport: () => {
            log.debug('doCancelImport()');
            dispatch(EXCHANGE_RATES_CONTROLLER.cancelImport());
        },
        onImportExchangeRateXml: (uploadData,removeExistingRates, successHandler, errorHandler) => {
            log.debug('onImportExchangeRateXml: ',removeExistingRates, successHandler,errorHandler);
            dispatch(EXCHANGE_RATES_CONTROLLER.importExchangeRateXml(uploadData,removeExistingRates, successHandler,errorHandler));
        },

        doDownloadExchangeRatesCsv: (params) => {
            log.debug('doDownloadExchangeRatesCsv mapDispatchToProps:', params);
            dispatch(EXCHANGE_RATES_CONTROLLER.doDownloadExchangeRatesCsv(params));
        },

        removeToast: (id) => {
            log.debug('removeToast mapDispatchToProps:', id);
            dispatch(toastActions.removeToast(id));
        },

        onStartImportExchangeRates: (operationRequest, successCallback, failureCallback) => {
            log.debug('onStartImportExchangeRates: ', operationRequest);
            dispatch(EXCHANGE_RATES_CONTROLLER.doImportExchangeRates(operationRequest, successCallback, failureCallback));
        },
        
    };
}

export default  authorize({
    name: 'ExchangeRates',
    resource: connect(mapStateToProps, mapDispatchersToProps)(ExchangeRatesPage)
  }, AuthorizedResource, {
    showNotAuthorized: true
  });
